import React, {useState} from 'react'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {Summary} from '../publications/components/Publications'

const CVTeaser: React.FC = () =>  {
    const intl = useIntl()
    const [total, setTotal] = useState(0);
    const [totalPub, setTotalPub] = useState(0);
    return(
        <div className='card mb-5 mb-xl-10'>
            <div className='card-body pt-9 pb-0'>
                <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
                    <div className='flex-grow-1'>
                        <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                            <div className='d-flex flex-column'>
                                <div className='d-flex align-items-center mb-5'>
                                    <Link to='/cv' className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1'>
                                        {intl.formatMessage({id: 'EDHEC.RESEARCHER'})}<span className='text-muted fs-5'> ({total})</span>
                                    </Link>
                                </div>
                                <div className='d-flex align-items-center mb-2'>
                                    <Link to='/publications' className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1'>
                                        {intl.formatMessage({id: 'EDHEC.LABEL.PUBLICATIONS'})}<span className='text-muted fs-5'> ({totalPub})</span>
                                    </Link>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
                <Summary setTotal={setTotal} setTotalPub={setTotalPub}/>
            </div>
        </div>
    )
}
export default CVTeaser